var _Result_value, _Result_success, _Result_error, _Result_previousResult;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
/**
 * Encapsulates a value allowing for returning an envelope
 * that contains the possible outcomes of a method.
 */
export default class Result {
    constructor(success, value, error, previousResult) {
        _Result_value.set(this, void 0);
        _Result_success.set(this, void 0);
        _Result_error.set(this, void 0);
        _Result_previousResult.set(this, void 0);
        __classPrivateFieldSet(this, _Result_success, success, "f");
        __classPrivateFieldSet(this, _Result_value, value, "f");
        __classPrivateFieldSet(this, _Result_error, error, "f");
        __classPrivateFieldSet(this, _Result_previousResult, previousResult, "f");
    }
    get value() {
        return __classPrivateFieldGet(this, _Result_value, "f");
    }
    get success() {
        return __classPrivateFieldGet(this, _Result_success, "f");
    }
    get error() {
        return __classPrivateFieldGet(this, _Result_error, "f");
    }
    get previousResult() {
        return __classPrivateFieldGet(this, _Result_previousResult, "f");
    }
    static ok(value, previousResult) {
        return new Result(true, value, undefined, previousResult);
    }
    static fail(error, value, previousResult) {
        return new Result(false, value, error, previousResult);
    }
}
_Result_value = new WeakMap(), _Result_success = new WeakMap(), _Result_error = new WeakMap(), _Result_previousResult = new WeakMap();
